function formatter(options: Intl.DateTimeFormatOptions, timeZone?: string): Intl.DateTimeFormat {
  try {
    return new Intl.DateTimeFormat(undefined, timeZone ? { ...options, timeZone } : options);
  } catch {
    return new Intl.DateTimeFormat(undefined, options);
  }
}

function parse(iso: string): Date | null {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(iso: string, timeZone?: string): string {
  const date = parse(iso);
  return date ? formatter({ dateStyle: "medium", timeStyle: "short" }, timeZone).format(date) : iso;
}

export function formatDate(iso: string): string {
  const date = parse(iso);
  return date ? formatter({ dateStyle: "medium" }).format(date) : iso;
}

export function timeZoneLabel(timeZone: string): string {
  return timeZone.replaceAll("_", " ");
}
